import axios from 'axios'
import router from "../../router/index"
import {generatekey, sort} from '@/mixins/des.js'
import md5 from "js-md5"

axios.defaults.timeout = 30000;
axios.defaults.baseURL = process.env.DOMAIN_ENV;
axios.defaults.transformRequest = function (data) {
  return data instanceof FormData ? data : JSON.stringify({ //此处的data类型判断为重要点，
    ...data
  });
};
axios.interceptors.request.use(
  config => {
    try {
      if(config.data instanceof FormData){
        config.headers['Content-Type'] = 'application/form-data';
        let token = sessionStorage.getItem("agenttoken");
        if (token && token.length > 10) {
          config.data.append('Token',token)
        }
        const _t = Date.parse(new Date()) / 1000
        let keys = generatekey(16);
        config.data.append('keys',keys);
        config.data.append('_t' , _t)
        config.data.append('sign' , md5(keys + (token ? token : '') + _t + keys))
      }else {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        if (config.method === 'post') {
          if (config.data == undefined || config.data == '') config.data = {}
          config.data.keys = undefined;
          config.data.sign = undefined
          let token = sessionStorage.getItem('agenttoken');
          if (token && token.length > 10) {
            config.data.Token = token;
          }
          const _t = Date.parse(new Date()) / 1000
          let keys = generatekey(16);
          config.data.keys = keys;
          config.data._t = _t
          config.data.sign = md5(keys + (token ? token : '') + _t + keys)
        } else if (config.method === 'get') {
          if (config.params == undefined || config.params == '') config.params = {}
          config.params.keys = undefined;
          config.params.sign = undefined
          let token = sessionStorage.getItem('agenttoken');
          if (token) {
            config.params.Token = token;
          }
          const _t = Date.parse(new Date()) / 1000
          let keys = generatekey(16);
          config.params._t = _t
          config.params.keys = keys;
          config.params.sign = md5(keys + (token ? token : '') + _t + keys)
        }
      }
      return config;
    } catch (err) {
      throw  err
    }
  },
  error => {
    return Promise.reject(error.response);
  });
axios.interceptors.response.use(
  response => {
    if (response.data.code == "-1") {
      router.push({path: '/login'})
      return false;
    } else {
      return response.data;
    }
  },
  error => {
    return Promise.reject(error.response)
  });
export default axios;



// WEBPACK FOOTER //
// ./src/config/httpConfig/http.js